import { configureStore } from '@reduxjs/toolkit';
import mapEdgesReducer from '../features/mapEdges/mapEdgesSlice';

export const store = configureStore({
  reducer: {
    mapEdges: mapEdgesReducer,
  },
});